/**
 * `StatusDot` — ported from `Foyer_Dashboard_CURRENT.jsx` line 218.
 * Pulsing colored dot used in nav and lists.
 */

import { motion } from 'framer-motion';

import { useC } from '../../lib/theme.js';

export interface StatusDotProps {
  color?: string;
  pulse?: boolean;
}

export function StatusDot({ color, pulse = true }: StatusDotProps): JSX.Element {
  const C = useC();
  const c = color ?? C.lime;
  return (
    <span className="relative inline-flex" style={{ width: 8, height: 8 }}>
      {pulse && (
        <motion.span
          className="absolute inset-0 rounded-full"
          style={{ background: c, opacity: 0.4 }}
          animate={{ scale: [1, 2.2, 1], opacity: [0.4, 0, 0.4] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeOut' }}
        />
      )}
      <span className="absolute inset-0 rounded-full" style={{ background: c }} />
    </span>
  );
}
